import React from 'react';
import { Navigate, NavLink, Routes, Route } from 'react-router-dom';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import Paths from 'navigation/paths';
import { useProfile } from 'shared/hooks';
import MainWrapper from 'shared/components/layout/MainWrapper/MainWrapper';
import Sidebar from 'shared/components/layout/Sidebar/Sidebar';
import colors from 'styles/colors';

import { analyticsServiceLines } from './data';
import AnalyticsDashboard from './AnalyticsDashboard';

const SidebarItem = styled(NavLink)`
  margin: 10px 0;
  padding: 10px 30px;
  font-size: 17px;
  font-weight: 500;
  color: ${colors.secondary};

  &:hover {
    background: ${colors.background};
  }

  &.active {
    color: ${colors.white};
    background: ${colors.secondary};
  }
`;

const Analytics = () => {
  const { profileData } = useProfile();

  const permittedServiceLines = React.useMemo(() => {
    const assigned = new Set(
      (profileData?.analyticsServiceLines ?? []).map((s) => s.serviceLine),
    );
    return analyticsServiceLines.filter(({ serviceLine }) =>
      assigned.has(serviceLine),
    );
  }, [profileData?.analyticsServiceLines]);

  return (
    <>
      <Sidebar>
        {permittedServiceLines.map(({ path, label }) => (
          <SidebarItem
            key={path}
            to={`/${Paths.Analytics}/${path}`}
            replace
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            {label}
          </SidebarItem>
        ))}
      </Sidebar>
      <MainWrapper>
        {permittedServiceLines.length ? (
          <Routes>
            {permittedServiceLines.map(({ path, serviceLine }) => (
              <Route
                key={path}
                path={`${path}/*`}
                element={<AnalyticsDashboard serviceLine={serviceLine} />}
              />
            ))}
            <Route
              path="/"
              element={<Navigate to={permittedServiceLines[0].path} replace />}
            />
          </Routes>
        ) : (
          <Typography p={3}>No analytics dashboards are assigned.</Typography>
        )}
      </MainWrapper>
    </>
  );
};

export default Analytics;
